import { Descriptions, Typography } from "antd";

const { Text, Link } = Typography;

export const DescriptionComponent = ({ items, column = 1 }) => {
  return (
    <Descriptions
      bordered
      column={column}
      size="middle"
      labelStyle={{ fontWeight: 500 }}
      contentStyle={{ padding: "8px 16px" }}
    >
      {items.map((item, index) => {
        const isEmpty = !item.value || item.value === "null";
        const displayValue = isEmpty ? (
          <Text type="secondary">—</Text>
        ) : item.isLink ? (
          <Link
            href={`${item.linkType}${item.value}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.value}
          </Link>
        ) : (
          item.value
        );

        return (
          <Descriptions.Item key={index} label={item.label}>
            {displayValue}
          </Descriptions.Item>
        );
      })}
    </Descriptions>
  );
};
